import { createContext, Fragment, useContext, useReducer, useRef } from "react"
import { offcanvasReducer } from "./reducer"

import offcanvasStyle from "./offcanvas.module.css"


const OffcanvasContext = createContext()

export default function OffcanvasProvider({children}) {

    const ref = useRef()

    const [Component, dispatch] = useReducer(offcanvasReducer, <Fragment></Fragment>)

    function offcanvas_open(props) {
        dispatch(props)

        ref.current.style.width = '300px'
    }

    function offcanvas_close() {
        ref.current.style.width = '0px'
    }

    return(
        <OffcanvasContext.Provider
            value={{
                offcanvas_open,
                offcanvas_close
            }}
        >
            {children}

            <div
                ref={ref}
                className={offcanvasStyle['wrap']}
            >
                <div>{Component}</div>
            </div>
        </OffcanvasContext.Provider>
    )
}

export function useOffcanvas() {
    const context = useContext(OffcanvasContext)

    return context
}